import React, { useEffect, useState } from 'react';
import { IProcessingTable } from './processingTable.models';
import ProcessingCartBar from '../processingChartBar/processingChartBar.component';
import { Button, CircularProgress } from '@mui/material';
import ProcessingProgressBar from '../processingProgressBar/processingProgressBar.component';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  backIconNameStyles,
  backIconStyles,
  circularProgressStyles,
  columnsSpanStyles,
  columnsStyles,
  containerStyles,
  downloadButtonSlidingStyles,
  fileNameStyles,
  firstHeaderInnerStyles,
  firstHeaderRowStyles,
  loadingStyles,
  nameAndColumns,
  rowCellStyles,
  rowIdCellStyles,
  secondHeaderInnerStyles,
  secondHeaderRowStyles,
  secondHeaderSpanCategoricalStyles,
  secondHeaderSpanDateTimeStyles,
  secondHeaderSpanNumericalStyles,
  sortingStyles,
  tableScrollStyles,
  tableStyles,
  thirdHeaderRowStyles,
  topBlockButtonsBlockStyles,
  topBlockButtonsStyles,
  topBlockFirstButtonStyles,
  topBlockStyles
} from './processingTable.styles';
import ProcessingTableSummary from '../processingTableSummary/processingTableSummary.component';
import API from '../../../manager/API';
import { removeLastExtension } from '../../../helpers/removeExtension';
import { ReactComponent as PreprocessIcon } from './../../../../src/assets/svg/preprocess.svg';
import { ReactComponent as GroupByIcon } from './../../../../src/assets/svg/groupBy.svg';
import { ReactComponent as MergeIcon } from './../../../../src/assets/svg/merge.svg';
import { ReactComponent as SummaryBoxIcon } from './../../../../src/assets/svg/summary.svg';
import { ReactComponent as DownloadBoxIcon } from './../../../../src/assets/svg/download.svg';
import { ReactComponent as SortingArrowUpIcon } from './../../../../src/assets/svg/arrowUp.svg';
import { ReactComponent as SortingArrowDownIcon } from './../../../../src/assets/svg/arrowDown.svg';
import { toast } from 'react-toastify';
import ProcessingDatasourceSummaryModal from '../processingDatasourseSummaryModal/processingDatasourceSummaryModal.component';
import { dispatch, useAppSelector } from '../../../store/hooks';
import { summaryMiddleware, summarySelector } from '../../../store/slices/summary';
import { modelVisualisationsMiddleware, modelVisualisationsSelector } from '../../../store/slices/modelVisualisations';
import ProcessingChartBar from '../processingChartBar/processingChartBar.component';
import { checkInCategoryFrequencies, checkInPureHistogram } from './processingTable.constants';
import ProcessingPreprocess from '../processingPreprocess/processingPreprocess.component';
import { emptyBlock } from '../processingPreprocess/processingPreprocess.constants';
import { IBlock } from '../processingPreprocess/processingPreprocess.models';
import {
  setModelVisualisationsData,
  setModelVisualisationsStatus
} from '../../../store/slices/modelVisualisations/middleware';
import ProcessingMerge from '../processingMerge/processingMerge.component';
import { IProcessingMergeJoinBlock } from '../processingMerge/processingMergeBody/processingMergeJoin/processingMergeJoinInnerBlock/processingMergeJoinInnerBlock.models';
import { processingMergeJoinEmptyBlock } from '../processingMerge/processingMergeBody/processingMergeJoin/processingMergeJoinInnerBlock/processingMergeJoinInnerBlock.constants';
import ProcessingGroupBy from '../processingGroupBy/processingGropupBy.component';
import { processingGroupByEmptyBlock } from '../processingGroupBy/processingGroupBy.constants';
import { IProcessingGroupByBlock } from '../processingGroupBy/processingGroupBy.models';

const ProcessingTable: React.FC<IProcessingTable> = ({ setActiveStep, datasetOrUpload, processingInputData }) => {
  const { summaryData, summaryStatus } = useAppSelector(summarySelector.summaryData);
  const [previewData, setPreviewData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [processingTableSummaryOpen, setProcessingTableSummaryOpen] = useState(false);
  const [processingDatasourceSummaryModalOpen, setProcessingDatasourceSummaryModalOpen] = useState<boolean>(false);
  const [groupByOpen, setGroupByOpen] = useState<boolean>(false);
  const [preprocessOpen, setPreprocessOpen] = useState<boolean>(false);
  const [mergeOpen, setMergeOpen] = useState<boolean>(false);
  const [columnName, setColumnName] = useState<string>('');
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' } | null>(null);
  const { modelVisualisationsData, modelVisualisationsStatus } = useAppSelector(
    modelVisualisationsSelector.modelVisualisationsData
  );
  const [activeTab, setActiveTab] = useState('correlations');
  const [processingMergeActiveStep, setProcessingMergeActiveStep] = useState(1);
  const [showAll, setShowAll] = useState(false); // State to toggle "Show More/Less"

  const [downloading, setDownloading] = useState(false);
  const [blocks, setBlocks] = useState<IBlock[]>([emptyBlock({ id: 1, action: '', singleActionBody: {} })]);
  const [processingMergeJoinBlocks, setProcessingMergeJoinBlocks] = useState<IProcessingMergeJoinBlock[]>([
    processingMergeJoinEmptyBlock({ id: 1, singleActionBody: {} })
  ]);
  const [processingGroupByBlocks, setProcessingGroupByBlocks] = useState<IProcessingGroupByBlock[]>([
    processingGroupByEmptyBlock({ id: 1, singleActionBody: {} })
  ]);
  const [selectedActionOption, setSelectedActionOption] = useState<{
    [key: number]: { id: number; label: string } | null;
  }>({});
  const [isChecked, setIsChecked] = useState(false);
  const [newFileNameValue, setNewFileNameValue] = useState('');
  const [processingMergeNewFileNameValue, setProcessingMergeNewFileNameValue] = useState('');
  const [selectedMergeJoinOption, setSelectedMergeJoinOption] = useState<any>(null); // Store only `id` and `label` in the state
  const [extensionError, setExtensionError] = useState(false);
  const [processingMergeInputData, setProcessingMergeInputData] = useState<Object>({
    dataset: '',
    uploadedFileName: '',
    uploadedFileSize: 0
  });
  const [isDuplicateChecked, setIsDuplicateChecked] = useState(false);
  const [processingMergeUploadSucceeded, setProcessingMergeUploadSucceeded] = useState<boolean>(false);
  const [processingMergeUploadProgress, setProcessingMergeUploadProgress] = useState<number>(0);
  const [processingMergeUploadStatus, setProcessingMergeUploadStatus] = useState<string>('');

  const getPreviewUrl = `/data_operations/file_preview?filename=${
    datasetOrUpload === 'dataset' ? processingInputData.dataset : processingInputData.uploadedFileName
  }`;
  const getSummaryUrl = `/data_operations/data_summary?file_name=${
    datasetOrUpload === 'dataset' ? processingInputData.dataset : processingInputData.uploadedFileName
  }`;

  // Use optional chaining to safely access nested properties
  const headers = previewData?.preview_data ? Object.keys(previewData.preview_data) : [];
  const numberOfRows = previewData?.preview_data
    ? Math.min(previewData.preview_data[headers[0]]?.values.length || 0, 50)
    : 0;

  const headerClick = (header: string) => {
    setPreprocessOpen(false);
    setMergeOpen(false);
    setGroupByOpen(false);
    setProcessingTableSummaryOpen(true);
    setColumnName(header);
  };

  const handleProcessingDatasourceSummaryModalOpen = () => {
    setProcessingDatasourceSummaryModalOpen(true); // Open the modal
  };

  const handleProcessingDatasourceSummaryModalClose = () => {
    setProcessingDatasourceSummaryModalOpen(false); // Close the modal
  };

  const handleGroupByOpen = () => {
    setMergeOpen(false);
    setProcessingTableSummaryOpen(false);
    setPreprocessOpen(false);
    setGroupByOpen(true);
  };

  const handlePreprocessOpen = () => {
    setMergeOpen(false);
    setProcessingTableSummaryOpen(false);
    setPreprocessOpen(true);
    setGroupByOpen(false);
  };

  const handleMergeOpen = () => {
    setPreprocessOpen(false);
    setGroupByOpen(false);
    setProcessingTableSummaryOpen(false);
    setMergeOpen(true);
  };

  const handleMergeClose = () => {
    setMergeOpen(false); // Close the modal
    setIsDuplicateChecked(false);
    setProcessingMergeJoinBlocks([emptyBlock({ id: 1, singleActionBody: {} })]);
    setProcessingMergeActiveStep(1);
    setProcessingMergeUploadProgress(0);
    setProcessingMergeUploadStatus('');
    setProcessingMergeUploadSucceeded(false);
    setProcessingMergeNewFileNameValue('');
    setSelectedMergeJoinOption(null);
    setProcessingMergeInputData({
      dataset: '',
      uploadedFileName: '',
      uploadedFileSize: 0
    });
  };

  const handlePreprocessClose = () => {
    setPreprocessOpen(false); // Close the modal
    setBlocks([emptyBlock({ id: 1, action: '', singleActionBody: {} })]);
    setSelectedActionOption({});
    setIsChecked(false);
    setNewFileNameValue('');
  };
  const handleGroupByClose = () => {
    setGroupByOpen(false);
  };

  const downloadClick = async () => {
    const fileName = processingInputData.dataset;
    const downloadFileUrl = `/blob_file/download?file_name=${summaryData.filename}`;

    setDownloading(true); // Start the animation
    try {
      const downloadData = await API.download.downloadFile(downloadFileUrl);
      if (downloadData.status === 200) {
        toast.success(`Downloaded ${summaryData.filename}:`);
        setDownloading(false);
      } else {
        toast.error(removeLastExtension(downloadData.data.message));
        setDownloading(false);
      }

      const blob = new Blob([downloadData.data], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = summaryData.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(`Could not download ${summaryData.filename}:`);
      console.error(`An error occurred while downloading the file ${summaryData.filename}:`, error);
      setDownloading(false);
    } finally {
      setDownloading(false); // Stop the animation
    }
  };

  const closeProcessingTableSummary = () => {
    setProcessingTableSummaryOpen(false);
    setActiveTab('correlations');
    setShowAll(false);
  };

  // Fetch preview data asynchronously
  useEffect(() => {
    setModelVisualisationsStatus(0);
    setModelVisualisationsData({});
    const fetchPreviewData = async () => {
      setLoading(true);
      try {
        const response = await API.preview.getPreview(getPreviewUrl);

        if (!response) {
          throw new Error('Failed to fetch preview data');
        }
        if (response.data && response.data.file_id) {
          const getVisualisationsUrl = `/visualisations/get_visualisations?id=${response.data.file_id}`;
          dispatch(modelVisualisationsMiddleware.getModelVisualisations(getVisualisationsUrl));
        }
        setPreviewData(response.data);
      } catch (error) {
        console.error('Error fetching preview data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPreviewData();
    dispatch(summaryMiddleware.getSummary(getSummaryUrl));
  }, []);

  useEffect(() => {
    if (previewData && Object.keys(previewData).length > 0) {
      if (modelVisualisationsStatus !== 200 && modelVisualisationsStatus !== 0) {
        toast.error(modelVisualisationsData.data.message);
      }
    }
  }, []);

  // Sorting function
  const handleSort = (header: string, direction: 'asc' | 'desc') => {
    setSortConfig({ key: header, direction });
  };

  function handleBack() {
    setActiveStep(1);
  }

  const sortedRows = () => {
    if (!sortConfig || !previewData) return Array.from({ length: numberOfRows }, (_, index) => index);

    const { key, direction } = sortConfig;
    const rows = Array.from({ length: numberOfRows }, (_, index) => index);

    return rows.sort((a, b) => {
      const aValue = previewData.preview_data[key]?.values[a] ?? null;
      const bValue = previewData.preview_data[key]?.values[b] ?? null;

      // Handle null (N/A) values explicitly
      if (aValue === null && bValue !== null) {
        // In ascending order, place N/A before 0s but after all other numbers
        return direction === 'asc' ? -1 : 1;
      }
      if (aValue !== null && bValue === null) {
        // In ascending order, place N/A before 0s but after all other numbers
        return direction === 'asc' ? 1 : -1;
      }

      // Place 0s before all other numbers (but after N/A in ascending)
      if (aValue === 0 && bValue !== 0) {
        return direction === 'asc' ? -1 : 1;
      }
      if (aValue !== 0 && bValue === 0) {
        return direction === 'asc' ? 1 : -1;
      }

      // Sort other values normally
      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  };
  const rowIds = sortedRows();

  return (
    <>
      {loading ? (
        <div style={loadingStyles}>
          <CircularProgress style={circularProgressStyles} />
        </div>
      ) : Object.keys(modelVisualisationsData).length > 0 ? (
        <>
          <div>
            <div style={containerStyles}>
              <div style={topBlockStyles}>
                <div style={nameAndColumns}>
                  <div style={backIconNameStyles}>
                    <ArrowBackIosNewIcon style={backIconStyles} onClick={handleBack} />
                    <span style={fileNameStyles}>{removeLastExtension(summaryData.filename)}</span>
                  </div>
                  <div style={columnsStyles}>
                    <span></span>
                    <span style={columnsSpanStyles}>
                      {modelVisualisationsData?.shape?.rows} rows, {modelVisualisationsData?.shape?.columns} columns
                    </span>
                  </div>
                </div>
                <div style={topBlockButtonsBlockStyles}>
                  <Button
                    component="label"
                    variant="contained"
                    size="large"
                    sx={topBlockFirstButtonStyles}
                    onClick={handlePreprocessOpen}
                    startIcon={<PreprocessIcon width="16px" height="16px" color="#334063" />}
                  >
                    Preprocess
                  </Button>
                  <Button
                    component="label"
                    variant="contained"
                    size="large"
                    sx={topBlockFirstButtonStyles}
                    onClick={handleGroupByOpen}
                    startIcon={<GroupByIcon width="16px" height="16px" color="#334063" />}
                  >
                    Groupby
                  </Button>
                  <Button
                    component="label"
                    variant="contained"
                    size="large"
                    sx={topBlockFirstButtonStyles}
                    onClick={handleMergeOpen}
                    startIcon={<MergeIcon width="16px" height="16px" color="#334063" />}
                  >
                    Merge
                  </Button>
                  <Button
                    component="label"
                    variant="contained"
                    size="large"
                    sx={topBlockFirstButtonStyles}
                    onClick={handleProcessingDatasourceSummaryModalOpen}
                    startIcon={<SummaryBoxIcon width="16px" height="16px" color="#334063" />}
                  >
                    Summary
                  </Button>
                  <div>
                    <style>
                      {`
          @keyframes endlessSlide {
            0% {
              left: -100%;
            }
            100% {
              left: 100%;
            }
          }
        `}
                    </style>
                    <Button
                      component="label"
                      variant="contained"
                      size="large"
                      sx={{
                        ...topBlockButtonsStyles,
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                      startIcon={<DownloadBoxIcon width="16px" height="16px" color="#334063" />}
                      onClick={downloadClick}
                    >
                      <span style={{ position: 'relative', zIndex: 1 }}>Download</span>
                      {downloading && <div style={downloadButtonSlidingStyles} />}
                    </Button>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', position: 'relative' }}>
                <div style={{ ...tableScrollStyles, overflowY: 'auto', flex: 1 }}>
                  <table style={tableStyles}>
                    <thead>
                      <tr style={firstHeaderRowStyles}>
                        <th
                          key="id"
                          style={{
                            width: '50px',
                            minWidth: '50px',
                            maxWidth: '50px',
                            borderRight: '1px solid #B3B5B9',
                            padding: '8px'
                          }}
                        ></th>
                        {headers.map((header) => (
                          <th key={header} style={{ ...firstHeaderInnerStyles }}>
                            <div style={sortingStyles}>
                              <span>{header}</span>
                              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '5px' }}>
                                {/* Up Arrow */}
                                <SortingArrowUpIcon
                                  fontSize="medium"
                                  style={{
                                    cursor: 'pointer',
                                    stroke:
                                      sortConfig?.key === header && sortConfig.direction === 'asc'
                                        ? '#007BFF' // Blue when active
                                        : '#B3B5B9', // Gray otherwise
                                    transform:
                                      sortConfig?.key === header && sortConfig.direction === 'asc'
                                        ? 'scale(1.7)'
                                        : 'scale(1)', // Slightly larger if active
                                    transition: 'fill 0.3s ease, transform 0.3s ease'
                                  }}
                                  onClick={() => handleSort(header, 'asc')}
                                />
                                <SortingArrowDownIcon
                                  fontSize="medium"
                                  style={{
                                    cursor: 'pointer',
                                    stroke:
                                      sortConfig?.key === header && sortConfig.direction === 'desc'
                                        ? '#007BFF' // Blue when active
                                        : '#B3B5B9', // Gray otherwise
                                    transform:
                                      sortConfig?.key === header && sortConfig.direction === 'desc'
                                        ? 'scale(1.7)'
                                        : 'scale(1)', // Slightly larger if active
                                    transition: 'fill 0.3s ease, transform 0.3s ease'
                                  }}
                                  onClick={() => handleSort(header, 'desc')}
                                />
                              </div>
                            </div>
                          </th>
                        ))}
                      </tr>
                      <tr style={secondHeaderRowStyles}>
                        <th key="id" style={{ borderRight: ' 1px solid #B3B5B9', padding: '8px' }}></th>
                        {headers.map((header) => (
                          <th key={header} style={{ ...secondHeaderInnerStyles, minWidth: '320px', maxWidth: '320px' }}>
                            <span
                              style={
                                previewData.preview_data[header]?.type === 'object'
                                  ? secondHeaderSpanCategoricalStyles
                                  : previewData.preview_data[header]?.type === 'datetime64[ns]'
                                  ? secondHeaderSpanDateTimeStyles
                                  : secondHeaderSpanNumericalStyles
                              }
                            >
                              {previewData.preview_data[header]?.type === 'object'
                                ? 'Categorical'
                                : previewData.preview_data[header]?.type === 'datetime64[ns]'
                                ? 'Datetime'
                                : 'Numeric'}
                            </span>
                          </th>
                        ))}
                      </tr>
                      <tr style={thirdHeaderRowStyles}>
                        <th
                          key="id"
                          style={{ borderRight: '1px solid #B3B5B9', padding: '8px', maxWidth: '320px' }}
                        ></th>

                        {headers.map((header) => {
                          let content = null;
                          let isClickable = true; // Flag to determine if the header should be clickable

                          if (modelVisualisationsData && Object.keys(modelVisualisationsData).length > 0) {
                            if (previewData?.preview_data[header]?.type === 'object') {
                              if (!checkInCategoryFrequencies(modelVisualisationsData?.category_frequency, header)) {
                                const categoryData = Object.entries(
                                  (modelVisualisationsData?.category_frequency?.[header] as Record<string, any>) || {}
                                );
                                const remaining = categoryData.slice(3);
                                const firstThree =
                                  remaining.length > 1 ? categoryData.slice(0, 3) : categoryData.slice(0, 4);
                                const othersPercentage = remaining.reduce(
                                  (sum, [, value]) => sum + value.percentage,
                                  0
                                );
                                const othersCount = remaining.reduce((sum, [, value]) => sum + value.count, 0);

                                content = (
                                  <>
                                    <style>
                                      {`
                .progress-bar-others {
                  opacity: 0.6;
                }
              `}
                                    </style>
                                    {firstThree.map(([key, value]) => (
                                      <ProcessingProgressBar
                                        key={key}
                                        percentage={parseFloat((value.percentage * 100).toFixed(3))}
                                        name={key}
                                        counts={value.count}
                                        mode={false}
                                        bsCat={false}
                                      />
                                    ))}
                                    {remaining.length > 1 && (
                                      <div style={{ opacity: 0.6 }}>
                                        <ProcessingProgressBar
                                          key="others"
                                          percentage={parseFloat((othersPercentage * 100).toFixed(3))}
                                          counts={othersCount}
                                          name="Others"
                                          mode={false}
                                          bsCat={false}
                                        />
                                      </div>
                                    )}
                                  </>
                                );
                              } else {
                                content = (
                                  <>
                                    <span>{modelVisualisationsData?.category_frequency[header]}</span>
                                  </>
                                );
                                isClickable = false; // Disable clickability
                              }
                            }
                            if (
                              previewData?.preview_data[header]?.type !== 'object' &&
                              previewData?.preview_data[header]?.type !== 'datetime64[ns]'
                            ) {
                              if (!checkInPureHistogram(modelVisualisationsData?.pure_histogram, header)) {
                                content = (
                                  <ProcessingChartBar
                                    defaultChartBarData={modelVisualisationsData?.pure_histogram[header]}
                                    label=""
                                    open={true}
                                  />
                                );
                              } else {
                                content = (
                                  <>
                                    <span>{modelVisualisationsData?.pure_histogram[header].message_instead}</span>
                                  </>
                                );
                                isClickable = false; // Disable clickability
                              }
                            }
                            if (previewData?.preview_data[header]?.type === 'datetime64[ns]') {
                              content = (
                                <>
                                  <span>It is dateTime column</span>
                                </>
                              );
                              isClickable = false; // Disable clickability
                            }

                            return (
                              <th
                                key={header}
                                onClick={() => isClickable && headerClick(header)} // Only trigger click if it's clickable
                                style={{
                                  borderRight: '1px solid #B3B5B9',
                                  padding: '8px',
                                  maxWidth: '320px',
                                  minWidth: '320px',
                                  cursor: isClickable ? 'pointer' : 'not-allowed' // Change cursor if not clickable
                                }}
                              >
                                {content}
                              </th>
                            );
                          }
                        })}
                      </tr>
                    </thead>
                    <tbody style={{ position: 'relative', zIndex: '1' }}>
                      {rowIds.map((rowIndex) => (
                        <tr key={rowIndex} style={{ borderBottom: '1px solid #B3B5B9' }}>
                          <td
                            key="id"
                            style={{
                              ...rowIdCellStyles,
                              width: '50px',
                              minWidth: '50px',
                              maxWidth: '50px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {rowIndex + 1}
                          </td>
                          {headers.map((header) => (
                            <td
                              key={header}
                              style={{
                                ...rowCellStyles,
                                width: '320px', // Define the desired width
                                maxWidth: '320px', // Ensure the width is not exceeded
                                whiteSpace: 'nowrap', // Prevent wrapping of text
                                overflow: 'hidden', // Hide overflowing text
                                textOverflow: 'ellipsis' // Apply ellipsis
                              }}
                            >
                              {(() => {
                                const value = previewData.preview_data[header]?.values[rowIndex];
                                if (value === null || value === undefined) return '';
                                const original = previewData.preview_data[header]?.values?.[rowIndex];
                                if (previewData?.preview_data[header]?.type === 'float64' && Number.isInteger(value)) {
                                  return value.toFixed(1);
                                }
                                return value.toString();
                              })()}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      height: '100%',
                      width: '600px',
                      backgroundColor: 'white',
                      zIndex: 2,
                      overflowY: 'auto',
                      transition: 'transform 0.3s ease-in-out',
                      transform: processingTableSummaryOpen ? 'translateX(0)' : 'translateX(110%)',
                      boxShadow: processingTableSummaryOpen ? '0 0 10px rgba(0,0,0,0.2)' : 'none'
                    }}
                  >
                    <ProcessingTableSummary
                      summaryData={summaryData?.summary?.data_summary}
                      shapeData={modelVisualisationsData?.shape}
                      showAll={showAll}
                      setShowAll={setShowAll}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      histogramChartBarData={modelVisualisationsData?.color_histogram}
                      defaultChartBarData={modelVisualisationsData?.pure_histogram[columnName]}
                      biasReportChartData={modelVisualisationsData?.bias_report}
                      triangularChartBarData={modelVisualisationsData?.correlations.categoricals}
                      numericCorrelationsData={
                        columnName.length > 0 && modelVisualisationsData?.correlations?.numericals[columnName]
                      }
                      headerCategoryData={
                        columnName.length > 0 && modelVisualisationsData?.category_frequency?.[columnName]
                      }
                      biasReportCategoricalsData={
                        columnName.length > 0 && modelVisualisationsData?.bias_report?.categoricals[columnName]
                      }
                      label=""
                      open={processingTableSummaryOpen}
                      onClose={closeProcessingTableSummary}
                      columnName={columnName}
                      modelType={previewData && previewData.preview_data[columnName]?.type}
                    />
                  </div>
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      height: '100%',
                      width: '600px',
                      backgroundColor: 'white',
                      zIndex: 2,
                      overflowY: 'auto',
                      transition: 'transform 0.3s ease-in-out',
                      transform: groupByOpen ? 'translateX(0)' : 'translateX(110%)',
                      boxShadow: groupByOpen ? '0 0 10px rgba(0,0,0,0.2)' : 'none'
                    }}
                  >
                    <ProcessingGroupBy
                      setData={setPreviewData}
                      open={groupByOpen}
                      onClose={handleGroupByClose}
                      processingGroupByBlocks={processingGroupByBlocks}
                      setProcessingGroupByBlocks={setProcessingGroupByBlocks}
                      data={previewData?.preview_data}
                      originalFileName={previewData?.filename}
                    />
                  </div>
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      height: '100%',
                      width: '600px',
                      backgroundColor: 'white',
                      zIndex: 2,
                      overflowY: 'auto',
                      transition: 'transform 0.3s ease-in-out',
                      transform: preprocessOpen ? 'translateX(0)' : 'translateX(110%)',
                      boxShadow: preprocessOpen ? '0 0 10px rgba(0,0,0,0.2)' : 'none'
                    }}
                  >
                    <ProcessingPreprocess
                      isChecked={isChecked}
                      setIsChecked={setIsChecked}
                      newFileNameValue={newFileNameValue}
                      setNewFileNameValue={setNewFileNameValue}
                      data={previewData}
                      setData={setPreviewData}
                      summaryData={summaryData}
                      open={preprocessOpen}
                      onClose={handlePreprocessClose}
                      blocks={blocks}
                      setBlocks={setBlocks}
                      setSelectedActionOption={setSelectedActionOption}
                      selectedActionOption={selectedActionOption}
                    />
                  </div>
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      height: '100%',
                      width: '600px',
                      backgroundColor: 'white',
                      zIndex: 2,
                      overflowY: 'auto',
                      transition: 'transform 0.3s ease-in-out',
                      transform: mergeOpen ? 'translateX(0)' : 'translateX(110%)',
                      boxShadow: mergeOpen ? '0 0 10px rgba(0,0,0,0.2)' : 'none'
                    }}
                  >
                    <ProcessingMerge
                      isDuplicateChecked={isDuplicateChecked}
                      setIsDuplicateChecked={setIsDuplicateChecked}
                      data={previewData}
                      setData={setPreviewData}
                      selectedMergeJoinOption={selectedMergeJoinOption}
                      setSelectedMergeJoinOption={setSelectedMergeJoinOption}
                      extensionError={extensionError}
                      setExtensionError={setExtensionError}
                      open={mergeOpen}
                      onClose={handleMergeClose}
                      summaryData={summaryData}
                      processingMergeJoinBlocks={processingMergeJoinBlocks}
                      setProcessingMergeJoinBlocks={setProcessingMergeJoinBlocks}
                      processingMergeInputData={processingMergeInputData}
                      setProcessingMergeInputData={setProcessingMergeInputData}
                      processingMergeActiveStep={processingMergeActiveStep}
                      setProcessingMergeActiveStep={setProcessingMergeActiveStep}
                      processingMergeUploadStatus={processingMergeUploadStatus}
                      setProcessingMergeUploadStatus={setProcessingMergeUploadStatus}
                      processingMergeUploadProgress={processingMergeUploadProgress}
                      setProcessingMergeUploadProgress={setProcessingMergeUploadProgress}
                      processingMergeUploadSucceeded={processingMergeUploadSucceeded}
                      setProcessingMergeUploadSucceeded={setProcessingMergeUploadSucceeded}
                      processingMergeNewFileNameValue={processingMergeNewFileNameValue}
                      setProcessingMergeNewFileNameValue={setProcessingMergeNewFileNameValue}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*<ProcessingTableSummary*/}
          {/*  summaryData={summaryData?.summary?.data_summary}*/}
          {/*  shapeData={modelVisualisationsData?.shape}*/}
          {/*  showAll={showAll}*/}
          {/*  setShowAll={setShowAll}*/}
          {/*  activeTab={activeTab}*/}
          {/*  setActiveTab={setActiveTab}*/}
          {/*  histogramChartBarData={modelVisualisationsData?.color_histogram}*/}
          {/*  defaultChartBarData={modelVisualisationsData?.pure_histogram[columnName]}*/}
          {/*  biasReportChartData={modelVisualisationsData?.bias_report}*/}
          {/*  triangularChartBarData={modelVisualisationsData?.correlations.categoricals}*/}
          {/*  numericCorrelationsData={*/}
          {/*    columnName.length > 0 && modelVisualisationsData?.correlations?.numericals[columnName]*/}
          {/*  }*/}
          {/*  headerCategoryData={columnName.length > 0 && modelVisualisationsData?.category_frequency?.[columnName]}*/}
          {/*  biasReportCategoricalsData={*/}
          {/*    columnName.length > 0 && modelVisualisationsData?.bias_report?.categoricals[columnName]*/}
          {/*  }*/}
          {/*  label=""*/}
          {/*  open={processingTableSummaryOpen}*/}
          {/*  onClose={closeProcessingTableSummary}*/}
          {/*  columnName={columnName}*/}
          {/*  modelType={previewData && previewData.preview_data[columnName]?.type}*/}
          {/*/>*/}
          {/*<ProcessingGroupBy*/}
          {/*  setData={setPreviewData}*/}
          {/*  open={groupByOpen}*/}
          {/*  onClose={handleGroupByClose}*/}
          {/*  processingGroupByBlocks={processingGroupByBlocks}*/}
          {/*  setProcessingGroupByBlocks={setProcessingGroupByBlocks}*/}
          {/*  data={previewData?.preview_data}*/}
          {/*  originalFileName={previewData?.filename}*/}
          {/*/>*/}
          {/*<ProcessingPreprocess*/}
          {/*  isChecked={isChecked}*/}
          {/*  setIsChecked={setIsChecked}*/}
          {/*  newFileNameValue={newFileNameValue}*/}
          {/*  setNewFileNameValue={setNewFileNameValue}*/}
          {/*  data={previewData}*/}
          {/*  setData={setPreviewData}*/}
          {/*  summaryData={summaryData}*/}
          {/*  open={preprocessOpen}*/}
          {/*  onClose={handlePreprocessClose}*/}
          {/*  blocks={blocks}*/}
          {/*  setBlocks={setBlocks}*/}
          {/*  setSelectedActionOption={setSelectedActionOption}*/}
          {/*  selectedActionOption={selectedActionOption}*/}
          {/*/>*/}
          {/*<ProcessingMerge*/}
          {/*  isDuplicateChecked={isDuplicateChecked}*/}
          {/*  setIsDuplicateChecked={setIsDuplicateChecked}*/}
          {/*  data={previewData}*/}
          {/*  setData={setPreviewData}*/}
          {/*  selectedMergeJoinOption={selectedMergeJoinOption}*/}
          {/*  setSelectedMergeJoinOption={setSelectedMergeJoinOption}*/}
          {/*  extensionError={extensionError}*/}
          {/*  setExtensionError={setExtensionError}*/}
          {/*  open={mergeOpen}*/}
          {/*  onClose={handleMergeClose}*/}
          {/*  summaryData={summaryData}*/}
          {/*  processingMergeJoinBlocks={processingMergeJoinBlocks}*/}
          {/*  setProcessingMergeJoinBlocks={setProcessingMergeJoinBlocks}*/}
          {/*  processingMergeInputData={processingMergeInputData}*/}
          {/*  setProcessingMergeInputData={setProcessingMergeInputData}*/}
          {/*  processingMergeActiveStep={processingMergeActiveStep}*/}
          {/*  setProcessingMergeActiveStep={setProcessingMergeActiveStep}*/}
          {/*  processingMergeUploadStatus={processingMergeUploadStatus}*/}
          {/*  setProcessingMergeUploadStatus={setProcessingMergeUploadStatus}*/}
          {/*  processingMergeUploadProgress={processingMergeUploadProgress}*/}
          {/*  setProcessingMergeUploadProgress={setProcessingMergeUploadProgress}*/}
          {/*  processingMergeUploadSucceeded={processingMergeUploadSucceeded}*/}
          {/*  setProcessingMergeUploadSucceeded={setProcessingMergeUploadSucceeded}*/}
          {/*  processingMergeNewFileNameValue={processingMergeNewFileNameValue}*/}
          {/*  setProcessingMergeNewFileNameValue={setProcessingMergeNewFileNameValue}*/}
          {/*/>*/}
          <ProcessingDatasourceSummaryModal
            open={processingDatasourceSummaryModalOpen}
            onClose={handleProcessingDatasourceSummaryModalClose}
            summaryData={summaryData}
            summaryStatus={summaryStatus}
          />
        </>
      ) : null}
    </>
  );
};

export default ProcessingTable;
